// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uMWw","title":"styles_title__eqjEQ"};